import { HOURS_PER_DAY, MILLIS_PER_SECOND, MINUTES_PER_HOUR, PRECISION, SECONDS_PER_DAY, SECONDS_PER_HOUR, SECONDS_PER_MINUTE, } from '../const/time.const';
import round from 'lodash/round';
import { FALLBACK_MESSAGE } from '../const/message.const';
import { DURATION_LABELS } from './constants/labels.const';
/**
 * Converts from seconds to minutes e.g. 120 (s) => 2 (m)
 * @param {number} seconds value to convert e.g. 120
 * @returns {number} time in minutes
 */
export function fromSecondsToMinutes(seconds) {
    return round(seconds / SECONDS_PER_MINUTE, 2);
}
/**
 * Converts from minutes to seconds e.g. 2 (m) => 120 (s)
 * @param {number} minutes value to convert e.g. 2
 * @returns {number} time in seconds
 */
export function fromMinutesToSeconds(minutes) {
    return minutes * SECONDS_PER_MINUTE;
}
export function fromDaysToSeconds(days) {
    return round(days * HOURS_PER_DAY * MINUTES_PER_HOUR * SECONDS_PER_MINUTE, 2);
}
/**
 * Converts from milliseconds to days e.g. 86400000 (ms) => 1 (d)
 * @param {number} milliseconds value to convert e.g. 86400000
 * @returns {number} time in days
 */
export const fromMillisecondsToDays = (milliseconds) => round(milliseconds / MILLIS_PER_SECOND / SECONDS_PER_DAY);
/**
 * Converts number of seconds to stopwatch format : 97534 -> 1 day 3 hours 05 min
 * @param {number} seconds value to convert e.g. 2
 * @param {precision} largest unit of precission of data presented
 * @example
  ```
    PRECISION.days: 1 day 3 hours 05 minutes
    PRECISION.hours: 27 hours 05 minutes
    PRECISION.minutes: 1625 minutes
  ```
  * @param {labels} Obiect with singular and plural labels
  * @example
  ```
    const SINGULAR: Dictionary<string> = {
      minute: 'minute',
      second: 'second',
    };

    const PLURAL: Dictionary<string> = {
      minute: 'minutes',
      second: 'seconds',
    };

    export const DURATION_LABELS = {
      SINGULAR,
      PLURAL,
    };
  ```
  * @returns {string}
 */
export function formatStopWatch(value, precision = PRECISION.days, labels = DURATION_LABELS) {
    if (!value) {
        return FALLBACK_MESSAGE.dash;
    }
    else if (value > 0 && value < 60) {
        return `0 ${labels.PLURAL.minute}`;
    }
    const days = precision === PRECISION.days ? Math.floor(value / SECONDS_PER_DAY) : 0;
    const hours = (precision === PRECISION.days || precision === PRECISION.hours) ? Math.floor((value - days * SECONDS_PER_DAY) / SECONDS_PER_HOUR) : 0;
    const minutes = Math.floor((value - days * SECONDS_PER_DAY - hours * SECONDS_PER_HOUR) / MINUTES_PER_HOUR);
    const isPlural = (period, count) => count === 1 ? labels.SINGULAR[period] : labels.PLURAL[period];
    const daysLabel = days ? ` ${days} ${isPlural('day', days)}` : '';
    const hoursLabel = hours ? ` ${hours} ${isPlural('hour', hours)}` : '';
    const minutesLabel = minutes ? ` ${minutes} ${isPlural('minute', minutes)}` : '';
    return `${daysLabel}${hoursLabel}${minutesLabel}`;
}
